import Label from "componentsTemplate/Label/Label";
import Textarea from "componentsTemplate/Textarea/Textarea";
import { get } from "lodash";
import { Editor } from "@tinymce/tinymce-react";
import { useRef } from "react";

const FormFieldTextArea = ({
  label,
  fieldName,
  extraProps = {},
  formData,
  handleChange,
  error = null,
}: any) => {
  const description: any = useRef(null);

  const saveEditorContent = (fieldName: any) => {
    if (description.current) {
      let content = description.current.getContent();
      handleChange(fieldName, content);
    }
  };

  return (
    <label className="block md:col-span-2" key={fieldName}>
      <Label>{label}</Label>
      <Editor
        id={fieldName}
        tinymceScriptSrc={"/tinymce/tinymce.min.js"}
        onInit={(evt, editor) => (description.current = editor)}
        onEditorChange={() => saveEditorContent(fieldName)}
        value={get(formData, fieldName)}
        init={{
          branding: false,
          placeholder: "",
          height: "400px",
          menubar: true,
          plugins: [
            "advlist",
            "autolink",
            "lists",
            "link",
            "charmap",
            "anchor",
            "searchreplace",
            "visualblocks",
            "code",
            "fullscreen",
            "insertdatetime",
            "media",
            "table",
            "preview",
            "wordcount",
            "variable",
          ],
          language: "pt_BR",
          toolbar: `blocks bold italic forecolor alignleft aligncenter alignright bullist numlist image table metadata nesteditem`,
          content_style:
            "body { font-family:Helvetica,Arial,sans-serif; font-size:18px }",
          paste_preprocess: function (plugin, args) {
            var doc = new DOMParser().parseFromString(
              args.content,
              "text/html"
            );
            var imgTags: any = doc.getElementsByTagName("img");
            while (imgTags.length > 0) {
              imgTags[0].parentNode.removeChild(imgTags[0]);
            }
            args.content = doc.body.innerHTML;
          },
        }}
      />
      {error && <span className="text-red-500 text-sm">{error}</span>}
    </label>
  );
};

export default FormFieldTextArea;
